import { Component } from '@angular/core';
import { Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import { BehaviorSubject } from 'rxjs';

/**
 * Component for managing user inactivity.
 */
@Component({
	selector: 'kv-idle',
	templateUrl: './idle.component.html',
	styleUrl: './idle.component.css'
})
export class IdleComponent implements OnInit {
	@Input() countdown$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	@Input() timedout$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	
	seconds: number = 0;
	expired: boolean = false;

	LOCALIZATION: any;

	constructor(
		private configService: ConfigService,
		private userService: UserService,
		private ngbModalService: NgbActiveModal
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.seconds = this.configService.getConfig().idleManager.timeout;
	}

	ngOnInit(): void {
		// Subscribe to the observables and update real time
		this.countdown$.subscribe(value => {
			this.seconds = value;
		});
		this.timedout$.subscribe(value => {
			this.expired = value;
		});		
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	logout(): void {
		let caller = {
			callerName: 'idle',
			action: 'logout'
		};

		if (this.ngbModalService) {
			this.ngbModalService.close({
				result: { answer: 'ok', caller: caller },
				timestamp: new Date(),
			});
		}
	}

	extend(): void {
		this.close();
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbModalService.dismiss();
	}
}
